function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.083,
    y1: 16.2945,
    x2: 64.1058,
    y2: 42.2878,
    gradientTransform: "matrix(1 0 0 -1 0 71.0471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#905CFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1649,
    style: {
      stopColor: "#6677F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3776,
    style: {
      stopColor: "#3596F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5401,
    style: {
      stopColor: "#17A9F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    style: {
      stopColor: "#0CB0F2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M66.9,47.5c-0.2-0.2-13.1-12.6-13.1-12.6s9.8-10.4,12.4-13c0.8-0.8,1.5-1.6,2-2.6     c3.6-6.1,1.5-13.9-4.6-17.5c-4.5-2.6-10.1-2.2-14.1,0.8c-0.7,0.5-1.3,1-1.9,1.6C47.3,4.6,33.7,17,21.9,27.8l22.1,14L20.8,67.9     c-1.4,1-2.8,1.6-4.3,1.9c0.3,0,0.5,0,0.8-0.1c4.6-0.7,43.9-7.3,45.8-7.7c2.3-0.4,4.4-1.8,5.7-3.9C71,54.5,70,50,66.9,47.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.31,
    y1: 42.9162,
    x2: 1.0679,
    y2: 68.7442,
    gradientTransform: "matrix(1 0 0 -1 0 71.0471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#905CFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07176042,
    style: {
      stopColor: "#A554E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2523,
    style: {
      stopColor: "#D641B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3901,
    style: {
      stopColor: "#F43597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    style: {
      stopColor: "#FF318C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M45.9,30.5c-0.4-2.7-1.8-4.9-3.8-6.5C40,22.4,23.8,5.6,22,3.7C19.2,1,15.2-0.5,11.1,0.2     C4.1,1.2-0.8,7.8,0.3,14.8c0.5,3.5,2.5,6.5,5.1,8.4c2.6,2,23,16,24.3,17c2.1,1.6,4.9,2.5,7.7,2C42.9,41.2,46.8,36,45.9,30.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.9829,
    y1: 12.3617,
    x2: 74.0226,
    y2: 55.8638,
    gradientTransform: "matrix(1 0 0 -1 0 71.0471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#905CFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1649,
    style: {
      stopColor: "#6677F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3776,
    style: {
      stopColor: "#3596F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5401,
    style: {
      stopColor: "#17A9F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6317,
    style: {
      stopColor: "#0CB0F2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M23,67.8c0.1,0,23.3-26.1,23.3-26.1L22.9,26.9c-8.3,7.6-16,14.5-17.8,16.2    c-1.1,1-2.2,2.3-3,3.7c-4.3,7.4-1.8,16.8,5.6,21.1C10.7,69.6,17.5,71.7,23,67.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 13.4,
    style: {
      fill: "#000000"
    },
    width: 43.2,
    height: 43.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.4,
    y: 48.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 16.2,
    height: 2.7
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "23.8,29.9 17,19.1 21.6,19.1 25.8,26.2 30.2,19.1 34.7,19.1 27.8,29.8 27.8,37 23.8,37       "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "41.6,22.7 36.1,22.7 36.1,19.1 51,19.1 51,22.7 45.5,22.7 45.5,37 41.6,37   "
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.7524b1a5.svg";
export { ForwardRef as ReactComponent };